import { types } from 'mobx-state-tree';

// Store
import store from '@clientCommon/app/bootstrap/store';

export default () => {
  return Array.from(store.models.kiosks.byId.values());
};
